export enum SortingDir {
    ASC = 'asc',
    DESC = 'desc',
}

export enum Sorting {
    NAME = 'name',
    CODE = 'code',
    TIME = 'time',
    TYPE = 'type',
    DISTANCE = 'distance',
}
